import { QueryFunctionContext } from '@tanstack/react-query';

import { ForcedRankingsService } from 'src/services/ForcedRankingsService';

export const QUERY_KEY = 'forced_ranking_strategy';

export const queryForcedRankingStrategy = (
    context: QueryFunctionContext<App.ForcedRankings.StrategyLookupQueryKey, number>,
): Promise<Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy> => {
    const { queryKey } = context;
    const [, accessToken, strategyName] = queryKey;

    return ForcedRankingsService.getForcedRankingStrategy(
        accessToken,
        strategyName,
    );
};
